import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SEO from '../components/SEO';
import useRouteSEO from '../hook/useRouteSEO';
import { useSEO } from '../context/SEOContext';

const SEOLayout = ({ children }) => {
    const location = useLocation();
    const { dynamicSEO } = useSEO();
    const routeSEO = useRouteSEO(dynamicSEO);
    const dynamicSEOSerialized = JSON.stringify(dynamicSEO);

    useEffect(() => {
        document.title = routeSEO.title || 'BoleumLearn';
    }, [routeSEO.title]);

    useEffect(() => {
        if (window.gtag) {
            window.gtag("config", "GA_MEASUREMENT_ID", {
                page_path: location.pathname,
                page_title: routeSEO.title,
                page_location: routeSEO.canonical,
            });
        }

        window.scrollTo(0, 0);
    }, [location.pathname, routeSEO.title, routeSEO.canonical, dynamicSEOSerialized]);

    return (
        <>
            <SEO
                key={location.pathname}
                title={routeSEO.title}
                description={routeSEO.description}
                keywords={routeSEO.keywords}
                image={routeSEO.image}
                robots={routeSEO.robots}
                canonical={routeSEO.canonical}
            />
            {children}
        </>
    );
};

export default SEOLayout;